import React, { useState, useEffect } from 'react';
import { setToken } from '../utils/token';
import { useAuth } from './AuthContext';
import apiService from '../services/ApiService';
import { useLocation, Link } from 'react-router-dom';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { login } = useAuth();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        // Obsługa komunikatów aktywacyjnych
        if (params.get('activationStatus') === 'ok') {
            setSuccess('Konto zostało aktywowane! Możesz się zalogować.');
        } else if (params.get('activationStatus') === 'already') {
            setSuccess('To konto jest już aktywowane. Możesz się zalogować.');
        } else if (params.get('activationStatus') === 'error') {
            setError('Link aktywacyjny jest nieprawidłowy lub wygasły.');
        }

        if (params.get('registration') === 'success') {
            setSuccess('Konto zostało utworzone! Na podany adres email wysłaliśmy link aktywacyjny. Sprawdź swoją skrzynkę pocztową i aktywuj konto.');
        }

        if (params.get('passwordReset') === 'success') {
            setSuccess('Hasło zostało zmienione! Możesz się zalogować używając nowego hasła.');
        }

        if (params.get('wpLogin') === 'true') {
            setError('Zaloguj się tutaj używając swoich danych. Nie używaj panelu WordPress.');
        }

        if (params.get('passwordSent') === 'success') {
            setSuccess('Link do resetowania hasła został wysłany na podany adres email. Sprawdź swoją skrzynkę pocztową.');
        }
    }, [location.search]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const response = await apiService.login(email, password);

            if (response.success) {
                setSuccess('Zalogowano pomyślnie!');
                setToken(response.token);
                login(response.token, response.user.email);
                // Event 'userLoggedIn' wysłany automatycznie w AuthContext.login()

                window.location.href = '/account';
            } else {
                setError(response.message || 'Błąd logowania');
            }
        } catch (error) {
            setError('Błąd połączenia z serwerem.');
        }
    };

    return (
        <div className="auth-page">
        <div className="auth-container">
        {/* Panel formularza logowania */}
        <div className="auth-form-panel">
        <h2 className="auth-form-title">Zaloguj się</h2>

        {/* Komunikaty systemowe */}
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
        <div className="auth-form-group">
        <label className="auth-form-label">Adres e-mail</label>
        <input
        type="email"
        className="auth-form-input"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Hasło</label>
        <input
        type="password"
        className="auth-form-input"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
        />
        </div>

        <button className="auth-submit-btn" type="submit">
        ZALOGUJ
        </button>
        </form>

        <Link to="/forgotpass" className="auth-forgot-link">
        Zapomniałem hasła
        </Link>
        </div>

        {/* Panel z benefitami */}
        <div className="auth-benefits-panel">
        <h2 className="auth-benefits-title">Drukuj online z Geometry Hustlers</h2>
        <p className="auth-benefits-subtitle">Profesjonalny druk 3D dostępny 24/7</p>

        <ul className="auth-benefits-list">
        <li className="auth-benefits-item"><span className="auth-benefits-icon">✓</span> Natychmiastowe zamawianie części przez konfigurator</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">✓</span> Silnik automatycznej wyceny oparty na slicerze</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">✓</span> Szybkie czasy realizacji</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">✓</span> Bezpieczne połączenie, poufność zachowana</li>
        </ul>

        {/* Sekcja rejestracji */}
        <div className="auth-register-section">
        <p className="auth-register-text">Nie masz jeszcze konta?</p>
        <Link to="/register" className="auth-register-btn">
        ZAREJESTRUJ SIĘ
        </Link>
        </div>
        </div>
        </div>
        </div>
    );
}

export default LoginPage;
